import { MARKETPLACE_ORDER_HANDOFF_DEFAULT_ITEMS } from "@nexus/contracts";

import {
  isOrgSettingsHandoffChangedField,
  type OrgSettingsChangedField,
  type OrgSettingsFieldTab,
  type OrgSettingsHandoffChangedField,
} from "./org-settings-dirty";

type Translate = (key: string, defaultValue: string) => string;

const FIELD_LABEL_DEFAULTS: Record<Exclude<OrgSettingsChangedField, OrgSettingsHandoffChangedField>, string> = {
  name: "Organization name",
  description: "Internal note",
  brandColor: "Accent color",
  type: "Type",
  productLine: "Product line",
  retoolUserId: "Retool user ID",
  industryIndices: "Industries",
  logo: "Logo",
  defaultIndustry: "Default industry",
  defaultBrand: "Default brand",
  preflightMarketRefs: "Markets",
  industryDefaultBrands: "Industry default brands",
  customerPartition: "Customer partition",
  marketplaceOrdersInboxEmails: "CC on order emails",
  conversionsMonthly: "Monthly conversions",
  conversionsWeekly: "Weekly conversions",
  currency: "Display currency",
  bqSyncFailureSlackAlertEnabled: "Sync failure Slack alert",
  enabledOpportunityTypes: "Opportunity types",
};

const TAB_LABELS: Record<OrgSettingsFieldTab, { key: string; defaultValue: string }> = {
  general: { key: "iam.orgDrawer.tabs.general", defaultValue: "General" },
  organization: { key: "iam.orgDrawer.tabs.organization", defaultValue: "Organization" },
  marketplace: { key: "iam.orgDrawer.tabs.orders", defaultValue: "Orders" },
};

export function orgSettingsFieldLabel(t: Translate, field: OrgSettingsChangedField): string {
  if (isOrgSettingsHandoffChangedField(field)) return handoffFieldLabel(t, field);
  return t(`iam.orgDrawer.footer.fields.${field}`, FIELD_LABEL_DEFAULTS[field]);
}

export function orgSettingsTabLabel(t: Translate, tab: OrgSettingsFieldTab): string {
  return t(TAB_LABELS[tab].key, TAB_LABELS[tab].defaultValue);
}

function handoffFieldLabel(t: Translate, field: OrgSettingsHandoffChangedField): string {
  const key = field.slice("handoff.".length);
  const item = MARKETPLACE_ORDER_HANDOFF_DEFAULT_ITEMS.find((row) => row.key === key);
  return t(`marketplace.handoff.fields.${key}.label`, item?.label ?? key);
}
